import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c80206d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container text-center text-dark mt-5" }
const _hoisted_2 = {
  id: "main",
  class: "container"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "NIF Yield", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "NDF Yield", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "NTF Yield", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "login-submit" }, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "submit",
    name: "wp-submit",
    class: "button-primary",
    value: "Submit"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          name: "loginform",
          id: "loginform",
          action: "#",
          method: "post",
          class: "wpl-track-me",
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendForm && _ctx.sendForm(...args)), ["prevent"]))
        }, [
          _createElementVNode("p", null, [
            _hoisted_3,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "log",
              id: "user_login",
              class: "input",
              placeholder: "Islamic Fund Yield",
              size: "20",
              required: "",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.nify) = $event))
            }, null, 512), [
              [_vModelText, _ctx.nify]
            ])
          ]),
          _createElementVNode("p", null, [
            _hoisted_4,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "pwd",
              id: "user_pass",
              class: "input",
              placeholder: "Dollar Fund Yield",
              required: "",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ndfy) = $event)),
              size: "20"
            }, null, 512), [
              [_vModelText, _ctx.ndfy]
            ])
          ]),
          _createElementVNode("p", null, [
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "pwd",
              id: "user_pass",
              class: "input",
              placeholder: "Turbo Fund Yield",
              required: "",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ntfy) = $event)),
              size: "20"
            }, null, 512), [
              [_vModelText, _ctx.ntfy]
            ])
          ]),
          _hoisted_6,
          _hoisted_7
        ], 32)
      ])
    ])
  ]))
}